import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DiscordPopupComponent} from './discord-popup.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material';



@NgModule({
  declarations: [DiscordPopupComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class DiscordPopupModule { }
